<div>
    <div class="card m-3">
        <h5 class="card-header" style="font-size: 21px">
            Payment Not Update Issue Details
        </h5>
        <div class="card-body">

            <form [formGroup]="pduStatusForm" (ngSubmit)="onSubmit()">
                <div class="form-row">

                    <div class="form-group col-3">
                        <label>Ticket Id</label>
                        <input type="text" class="form-control" [value]="ticketId" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Grievance Date</label>
                        <input type="text" class="form-control" [value]="entrydate" [attr.disabled]='true' />
                    </div>


                    <div class="form-group col-3">
                        <label>Single Roll No</label>
                        <input type="text" class="form-control" [value]="singlerollno" [attr.disabled]='true' />
                    </div>




                    <div class="form-group col-3">
                        <label>Name</label>
                        <input type="text" class="form-control" [value]="name" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Email</label>
                        <input type="text" class="form-control" [value]="email" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-12">
                        <label>Bulk Roll No</label>
                        <input type="text" class="form-control" [value]="bulkregno" [attr.disabled]='true' />
                    </div>


                    <div class="form-group col-3">
                        <label>Mobile No</label>
                        <input type="text" class="form-control" [value]="mobileno" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>State</label>
                        <input type="text" class="form-control" [value]="state" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>District</label>
                        <input type="text" class="form-control" [value]="district" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>ITI Code</label>
                        <input type="text" class="form-control" [value]="iticode" [attr.disabled]='true' />
                    </div>

                    <!-- <div class="form-group col-3">
                        <label>Trade</label>
                        <input type="text" class="form-control" [value]="trade" [attr.disabled]='true' />
                    </div> -->

                    <div class="form-group col-3">
                        <label>CCREF No</label>
                        <input type="text" class="form-control" [value]="ccrefno" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>CCREF No Status</label>
                        <input type="text" class="form-control" [value]="ccrefnoStatus" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Order Id</label>
                        <input type="text" class="form-control" [value]="orderid" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Date</label>
                        <input type="text" class="form-control" [value]="date" [attr.disabled]='true' />
                    </div>



                </div>
                <div class="form-row">

                    <div class="form-group col-3">
                        <label>Number Of Stud</label>
                        <input type="text" class="form-control" [value]="numberofstud" [attr.disabled]='true' />
                    </div>


                    <div class="form-group col-3">
                        <label>Amount</label>
                        <input type="text" class="form-control" [value]="amount" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Description</label>
                        <input type="text" class="form-control" [value]="descreption" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-12">
                        <hr>
                    </div>
                </div>



                <div class="form-row">
                    <div class="form-group col-12">
                        <h2>Remarks</h2>
                    </div>

                    <div class="form-group col-3">
                        <label>Grievance Status</label>
                        <select formControlName="status" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.status.errors }">
                            <option value="resolved">Resolved</option>
                            <option value="rejected">Rejected</option>
                        </select>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.status.errors.required">status is required</div>
                        </div>

                    </div>

                    <div class="form-group col-12">
                        <label>Remarks</label>
                        <textarea class="form-control" formControlName="statusDescription"
                            [ngClass]="{ 'is-invalid': submitted && f.statusDescription.errors }"
                            maxlength="500"></textarea>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.statusDescription.errors.required">statusDescription is required</div>
                        </div>

                    </div>

                    <div class="form-group col-12">
                        <hr>
                    </div>

                    <div class="form-group col-12">


                        <button class="btn btn-primary mr-1">Submit</button>

                    </div>

                </div>
            </form>

        </div>
    </div>
</div>